import { Team__FoxImpresos } from "../teams/FoxImpresos";
import { Team__Apaches } from "../teams/Apaches";
import { Team__Coyotes } from "../teams/Coyotes";
import { Team__Aliados } from "../teams/Aliados";
import { Team__FloresMagon } from "../teams/FloresMagon";
import { Team__Nogaleros } from "../teams/Nogaleros";

const FoxImpresos = {
  team: Team__FoxImpresos,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

const Coyotes = {
  team: Team__Coyotes,
  playingPlayers: [],

  goals: 56,
  penaltyGoals: 0,
  isWinner: false,
};

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const FloresMagon = {
  team: Team__FloresMagon,
  playingPlayers: [],

  goals: 39,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: FoxImpresos,
      team2: Apaches,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Coyotes,
      team2: Aliados,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: FloresMagon,
      team2: Nogaleros,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
